import { map } from "rxjs";
import { GET } from "../../module/services/fetch";

export const fetchTablesConfiguration = () =>
  GET(`v1/configurations/tables`).pipe(map((response: any) => response));
